import React, {useState, useEffect} from 'react';
import NavigationMenu from './NavigationMenu';
import styles from './Pronounce.module.css'
import BlurredTextBox from './BlurredTextBox';
import { ChromePicker } from "react-color";
import axios from 'axios';

function Pronounce(){
    var sideNavSize = 300;
    const [isCollapsed, setIsCollapsed] = useState(window.innerWidth < 768); // State for tracking collapsed status
    const [word, setWord] = useState("");
    const [selectedOption, setSelectedOption] = useState("Arial");
    const [selectedColor, setSelectedColor] = useState("#ffffff");
    const [selectedBackgroundColor, setSelectedBackgroundColor] = useState("#ffffff");
    const [selectedAccentColor, setSelectedAccentColor] = useState("#ffffff");
    const [isChecked, setIsChecked] = useState(false);
    const [sliderValue, setSliderValue] = useState(1);
    const [userPreferences, setUserPreferences] = useState(null);

    useEffect(() => {
        console.log("Pronounce mounted");
      
        return () => {
          console.log("Pronounce unmounted");
        };
      }, []);

    useEffect(() => {
        // Fetch user preferences on component mount
        const fetchUserPreferences = async () => {
          try {
            const response = await axios.get('/api/user/PronouncePreferences/' + localStorage.getItem("_id")); 
            const preferences = JSON.parse(response.data.preferences); // Assuming the preferences are returned as an object
            setUserPreferences(preferences);
            setWord(preferences.pronouns);
            setSelectedOption(preferences.font);
            setSelectedColor(preferences.fontColour);
            setSelectedBackgroundColor(preferences.backgroundColour);
            setSelectedAccentColor(preferences.accentColour);
            setIsChecked(preferences.alwaysDisplay);
            setSliderValue(preferences.displayFrequency);
            // updatePronouncePreferences();
        } catch (error) {
            console.error('Error fetching user preferences:', error);
            setWord("pro/nounce");
            setSelectedOption("Arial");
            setSelectedColor("#E6FF46");
            setSelectedBackgroundColor("#0491F0");
            setSelectedAccentColor("#E6FF46");
            setIsChecked(false);
            setSliderValue(1);
            const preferences = JSON.stringify({ 
                "pronouns": word,
                "font": selectedOption,
                "fontColour": selectedColor,
                "backgroundColour": selectedBackgroundColor,
                "accentColour": selectedAccentColor,
                "alwaysDisplay": isChecked,
                "displayFrequency": sliderValue,
            });
            setUserPreferences(preferences);
        }
        };
    
        fetchUserPreferences();
      }, []);


    useEffect(() => {
        function handleResize() {
          setIsCollapsed(window.innerWidth < (768 + sideNavSize));
        }
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
        }
        , []);

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleColorChange = (color) => {
        setSelectedColor(color.target.value);
    

    };

    const handleBackgroundColorChange = (color) => {
        setSelectedBackgroundColor(color.target.value);
    };

    const handleAccentColorChange = (color) => {
        setSelectedAccentColor(color.target.value);
    };

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };

    const handleSliderChange = (event) => {
        setSliderValue(parseInt(event.target.value));
    };

    const textInputChange = (event) => {
        setWord(event.target.value)
    };

    const handleClickSave = async (event) => {
        console.log("lollllllllllllllllllllllllllllll");
        event.preventDefault(); // Prevent form submission
    
        try {
            console.log("Saving preferences...");
            await saveUserPronouncePreferences();
            console.log("Preferences saved.");
            // Ensure no navigation or reload is triggered here
        } catch (error) {
            console.error("Error saving preferences:", error);
        }
    };

    
      function updatePronouncePreferences(){    
        document.getElementById("lowerThirdText").innerHTML = word;
        document.getElementById("lowerThirdText").style.fontFamily = selectedOption;
        document.getElementById("lowerThirdText").style.color = selectedColor;
        document.getElementById("lowerThird").style.backgroundColor = selectedBackgroundColor;
        document.getElementById("lowerThird").style.color = accentColour;
        
      }
    
      
   async function saveUserPronouncePreferences(){
        const requestOptions = {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                "pronouns": word,
                "font": selectedOption,
                "fontColour": selectedColor,
                "backgroundColour": selectedBackgroundColor,
                "accentColour": selectedAccentColor,
                "alwaysDisplay": isChecked,
                "displayFrequency": sliderValue,
                "userId": localStorage.getItem("_id")
            })
        };
        await fetch('https://dev.super-stream.co/api/user/PronouncePreferences', requestOptions)
            .then(response => response.json())
            .then(data => {
                console.log(data);
            });
    }

    const bannerStyle = {
        color: selectedAccentColor,
        backgroundColor: selectedBackgroundColor
    };

    const bannerTextStyle = {
        color: selectedColor,
        fontFamily: selectedOption
    };

    return (
        <div className={`container-fluid`}>
          <div className="row">
              <div className="col">
                <div className="row">
                    <div className={`col-2 nonScrollable ${isCollapsed ? `hideSidebar` : `showSidebar`}`}  style={{paddingRight: 0, paddingLeft: 0, width: sideNavSize + 'px'}}>
                        <NavigationMenu />
                    </div>
                    <div className={` col scrollable ${isCollapsed ? 'col-12' : ''}`} style={{ order: 1 }}>
                        <div className="scrollableContent">
                            <div className="App content-centered">  
                                    <div className='row'> {/* this is to make a grid system within the app window */}
                                        <div className={styles.box}>
                                            <img className={`${styles.logoBanner} img-fluid object-fit-scale`} src="pronounce.png"></img>
                                            {/* <h1 style={{color: 'black'}}>Showcase</h1> */}
                                        </div>
                                    </div> 

                                    <div className={styles.contained}>
                                            <div className={`row `}> {/* this is to make a grid system within the app window */}
                                                <div className='col-12 col-md-12 col-sm-12  '>
                                                    <div className={`row `}>
                                                        <div className={`${styles.box} `}>
                                                            <h2>Display your pronouns with pride</h2>
                                                        </div>
                                                    </div>
                                                    <div className={`row `}>
                                                            <BlurredTextBox text={"https://super-stream.co/pronounce/" + localStorage.getItem("_id")}></BlurredTextBox>
                                                    </div>
                                                </div>
                                            </div>                                    
                                    </div>  

                                    <div className={styles.contained}>
                                            <div className={`row `}> {/* this is to make a grid system within the app window */}
                                                <div className='col-12 col-md-12 col-sm-12  '>
                                                    <div className={`${styles.box} `}>
                                                        <h2>Widget preview:</h2>
                                                    </div>
                                                    <div className={`${styles.box} `}>
                                                        <div id="lowerThird" className={styles.lowerThird} style={bannerStyle}>
                                                            <h1 id="lowerThirdText" style={bannerTextStyle}>{word === "" ? 'pro/nounce' : word}</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                    
                                    </div>  

                                    <div className={styles.contained}>
                                            <div className={`row `}> {/* this is to make a grid system within the app window */}
                                                    <div className='col-12 col-md-12 col-sm-12  '>
                                                        <p>Pronouns (eg: he/him):</p>
                                                        <div className={`${styles.box} `}>
                                                            <input
                                                                type="text"
                                                                value={word}
                                                                onChange={textInputChange}
                                                                placeholder="My/Pronouns"
                                                            />
                                                        </div>
                                                        <p>Font: </p>
                                                        <div className={`${styles.box} `}>
                                                                <select value={selectedOption} onChange={handleChange}>
                                                                    <option value="Arial">Arial</option>
                                                                    <option value="Helvetica">Helvetica</option>
                                                                    <option value="Times New Roman">Times New Roman</option>
                                                                </select>
                                                        </div>
                                            </div>
                                            <div className={`row `}> {/* this is to make a grid system within the app window */}
                                                    <div className='col-4 col-md-4 col-sm-4  '>
                                                    <div className={`${styles.box}`}>
                                                        <span>Font Colour:</span>
                                                        <input
                                                            type="color"
                                                            id="font"
                                                            name="font"
                                                            value={selectedColor}
                                                            onChange={handleColorChange}
                                                        />
                                                        </div>
                                                    </div>
                                                    <div className='col-4 col-md-4 col-sm-4  '>
                                                    <div className={`${styles.box}`}>
                                                        <span>Background Colour:</span>
                                                        <input
                                                            type="color"
                                                            id="background"
                                                            name="background"
                                                            value={selectedBackgroundColor}
                                                            onChange={handleBackgroundColorChange}
                                                        />
                                                        </div>
                                                    </div>

                                                    <div className='col-4 col-md-4 col-sm-4  '>
                                                    <div className={`${styles.box}`}>
                                                        <span>Accent Colour:</span>
                                                        <input
                                                            type="color"
                                                            id="accent"
                                                            name="accent"
                                                            value={selectedAccentColor}
                                                            onChange={handleAccentColorChange}
                                                        />
                                                        </div>
                                                    </div>

                                                        <div className={`${styles.box} `}>
                                                            <span>
                                                                <input
                                                                type="checkbox"
                                                                checked={isChecked}
                                                                onChange={handleCheckboxChange}
                                                                />
                                                                 Always display pronouns
                                                            </span>
                                                        </div>
                                                        {isChecked ? (<></>) : (
                                                            <div className={`${styles.box} `}>
                                                            <p>Display frequency: </p>
                                                                <input
                                                                    type="range"
                                                                    min={1}
                                                                    max={60}
                                                                    value={sliderValue}
                                                                    onChange={handleSliderChange}
                                                                />
                                                                <p>Every {sliderValue} minute{sliderValue > 1 ? 's' : ''}</p>
                                                            </div>
                                                        )}
                                                    </div> 
                                                    <div className={`row `}> {/* this is to make a grid system within the app window */}
                                                        <div className='col-12 col-md-12 col-sm-12  '>
                                                            <div className={`${styles.box} `}>
                                                                <button type="button" onClick={handleClickSave}>Save</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                            </div>

                                    </div>

                                    <div className={styles.contained}>
                                      <div className={`row `}>
                                        <div className={styles.box}>
                                          <h2 className={styles.headings} style={{ fontFamily: 'Roboto' }}>Follow us on Twitter: @superstreamco</h2>
                                        </div>
                                      </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Pronounce;